<template>
    <span v-if="text && user && user.can_translate">
        <QrIcon
            icon="language"
            class="relative -bottom-0.5 cursor-pointer w-6 h-6 text-blue-500"
            @click="modalOpen = true"
        />

        <QrModal v-model="modalOpen" :title="text">
            <QrForm @submit.prevent="update" class="space-y-2">
                <QrInput label="English" v-model="english"/>
                <QrInput label="Norwegian" v-model="norwegian"/>
                <QrInput label="Swedish" v-model="swedish"/>
            </QrForm>

            <template #buttons>
                <QrButton @click="update" :loading="loading">
                    Save
                </QrButton>
            </template>
        </QrModal>
    </span>
</template>

<script setup>
import QrModal from "@/components/application-ui/dialogs/QrModal.vue";
import QrInput from "@/components/application-ui/form/QrInput.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import { onMounted, ref } from "vue";
import { trans } from "@/libs/helper.js";
import {useUserStore} from "@/store/user.js";
import {storeToRefs} from "pinia";

const props = defineProps({
    text: String,
});

const userStore = useUserStore();

const english = ref('');
const norwegian = ref('');
const swedish = ref('');
const loading = ref(false);
const modalOpen = ref(false);
const { user } = storeToRefs(userStore);

onMounted(() => {
    english.value = trans(props.text, null, 'en');
    norwegian.value = trans(props.text, null, 'no');
    swedish.value = trans(props.text, null, 'se');

    if (english.value === props.text) {
        english.value = null;
    }

    if (norwegian.value === props.text) {
        norwegian.value = null;
    }

    if (swedish.value === props.text) {
        swedish.value = null;
    }
});

const update = async () => {
    await axios.post(`/api/translate`, {
        key: props.text,
        en: english.value,
        no: norwegian.value,
        se: swedish.value,
    })

    modalOpen.value = false;
}

</script>
